import { Injectable } from '@angular/core';
import { AccountUsersApiClient } from './account-users.api.client';
import { AccountUsersInMemoryApiClientProvider as AccountUsersInMemoryApiClient } from './account-users.in-memory-api.client';
import { IAccountUsersApiClient } from './i-account-users.api.client';
import { ApiClientProvider } from '../../../../core';

@Injectable({
  providedIn: 'root'
})
export class AccountUsersApiClientProvider extends ApiClientProvider<IAccountUsersApiClient> {
  constructor(
    private client: AccountUsersApiClient,
    private inMemoryClient: AccountUsersInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IAccountUsersApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IAccountUsersApiClient {
    return this.client;
  }
}
